import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { ProjetoCadastroService } from '../../services/projeto-cadastro.service';
import { NavigationService } from '../../services/navigation.service';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MaskService } from 'src/app/shared/services/mask.service';

@Component({
  selector: 'app-detalhe-cadastro-projeto',
  templateUrl: './detalhe-cadastro-projeto.component.html',
  styleUrls: ['./detalhe-cadastro-projeto.component.scss']
})
export class DetalheCadastroProjetoComponent extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  idProjeto: number;
  projeto: ProjetoCadastro;
  loadingCronograma: boolean;
  isLoadingBlock: boolean;
  permissions: ProjetoPermission
  cronograma: any;

  modalPrintRef?: BsModalRef;
  filter_year_code: string = '';
  report_type: number = 2;
  reportList = [
    { id: 2, label: 'Relatório Sintético' },
    { id: 3, label: 'Relatório Completo' },
  ];
  report_2_param_2 = '';
  analiseList = [
    { id: '', label: 'Nenhuma' },
    { id: '1', label: 'Última' },
    { id: '2', label: 'Todas' },
  ];
  report_2_param_1 = [];
  tipoAnaliseList = [
    { id: 1, label: 'Análise do Gerente' },
    { id: 2, label: 'Análise Monitoramento' },
  ];
  report_3_param_1 = [];
  infoList = [
    { id: 1, label: 'Cadastro' },
  ];

  @ViewChild('modalPrint') modalPrint: TemplateRef<any>;

  constructor(
    private myService: ProjetoCadastroService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private navigation: NavigationService,
    private maskService: MaskService
  ) {
    super()
  }

  ngOnInit(): void {
    this.idProjeto = this.activatedRoute.parent.parent.snapshot.params.idProjeto;
    this.addSub(
      this.myService.getById(this.idProjeto, true).subscribe((res) => {
        this.projeto = res;
        this.filter_year_code = `"${this.projeto.year}.${this.projeto.code}"`;
        this.loaded();
        this.initLoadDataTable();
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable(obj = null) {
    this.loadingCronograma = true;
    this.addSub(
      this.myService.getCronogramaSearch(this.idProjeto, obj).subscribe((res) => {
        this.cronograma = res;
        this.loadingCronograma = false;
      })
    );
  }

  filtrarCronograma(value) {
    let obj = value.map(item => String(item.id));
    this.initLoadDataTable({ 'prod_id': obj });
  }

  editar() {
    this.router.navigate([`projetos/projeto/${this.idProjeto}/cadastro/editar`]);
  }

  voltar() {
    this.navigation.back([`projetos/projeto`]);
  }

  bloqueioProjeto(total = false) {
    this.isLoadingBlock = true;
    let obj = {};
    if (total) {
      obj = {
        full_blocked: this.projeto?.full_blocked ? "0" : "1",
      };
    } else {
      obj = {
        meta_blocked: this.projeto?.meta_blocked ? "0" : "1",
      };
    }
    this.addSub(
      this.myService.getBloqueio(this.idProjeto, obj).subscribe({
        next: (res) => {
          if (total) {
            this.projeto.full_blocked = !this.projeto.full_blocked;
          } else {
            this.projeto.meta_blocked = !this.projeto?.meta_blocked;
          }
          this.isLoadingBlock = false;
          this.msgSuccess(res?.message);
        },
        error: (err) => {
          this.isLoadingBlock = false;
          this.msgError(err.error?.message);
        },
      }),
    )
  }

  closePrintModal() {
    this.modalPrintRef?.hide();
  }

  openPrintModal() {
    this.modalPrintRef = this.modalService.show(this.modalPrint);
  }

  imprimirProjetos() {
    this.loading();
    let getData = {};
    getData['filter_year_code'] = this.filter_year_code;
    let tipo = "";
    if (this.report_type == 2) {
      tipo = "sintetico"
      getData['report_2_param_1'] = this.report_2_param_1
      getData['report_2_param_2'] = this.report_2_param_2
    } else if (this.report_type == 3) {
      tipo = "completo"
      getData['report_3_param_1'] = this.report_3_param_1
    } else {
      this.loaded();
      return;
    }

    let filtro = "";

    for (var key in getData) {
      if (getData.hasOwnProperty(key)) {
        // CASO SEJA UM OBJETO && VERIFICA SE É ARRAY
        if (typeof (getData[key]) == 'object' && Array.isArray(getData[key])) {
          // SE ESTIVER POPULADO INCLUI
          if (getData[key].length > 0) {
            filtro += `&${key}=${getData[key]}`;
          }
        } else {
          if (getData[key] != null) filtro += `&${key}=${getData[key]}`;
        }
      }
    }
    const url = `${environment.serverUrl}/rest/relatorios/${tipo}?report_type=${this.report_type}${filtro}`;
    this.loaded();
    window.open(url, '_blank');
  }

  get maskProjeto():string|number{
    return this.maskService.maskProjetoId(this.projeto.code) ?? this.projeto.code;
  }

}
